import { NgModule, ModuleWithProviders } from '@angular/core';
import { IfStableDirective } from './directives/app-if-stable.directive';

@NgModule({
    imports: [
    ],
    declarations: [IfStableDirective],
    providers:
        [

        ],
    exports: [IfStableDirective]
})
export class PrebootHelperModule { }
